


import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    mainTab: "All Trainings", // Default main tab
    subTab: "All", // Default sub tab
};

const trainingTabsSlice = createSlice({
    name: "s",
    initialState,
    reducers: {
        setMainTab: (state, action) => {
            state.mainTab = action.payload;
            // Reset sub-tab when main tab changes
            if (state.mainTab !== "All Trainings" && state.mainTab !== "In Progress") {
                state.subTab = ""; // Hide sub-tabs
            } else {
                state.subTab = "All"; // Default sub-tab
            }
        },
        setSubTab: (state, action) => {
            state.subTab = action.payload;
        },
        resetTabs: () => initialState,
    },
});

export const { setMainTab, setSubTab } = trainingTabsSlice.actions;
export default trainingTabsSlice.reducer;
